import { createBlueprint as e } from "@made-people/blueprint";
const a = e({
  slots: {
    base: "",
    heading: "text-balance",
    suffix: "",
    lead: "mt-4 lg:max-w-[800px] xl:max-w-[1000px] text-balance",
    eyebrow: "mb-2 lg:mb-3 flex",
    badge: "mb-2",
    prefix: "mr-2"
  },
  variants: {
    color: {
      black: {
        heading: "text-black",
        lead: "text-black",
        eyebrow: "text-black"
      },
      white: {
        heading: "text-white",
        lead: "text-white",
        eyebrow: "text-white"
      }
    },
    headingSize: {
      "2xs": {
        heading: "text-heading-2xs"
      },
      xs: {
        heading: "text-heading-xs"
      },
      sm: {
        heading: "text-heading-sm"
      },
      md: {
        heading: "text-heading-md"
      },
      lg: {
        heading: "text-heading-lg"
      },
      xl: {
        heading: "text-heading-xl"
      },
      "2xl": {
        heading: "text-heading-2xl"
      },
      "3xl": {
        heading: "text-heading-3xl"
      },
      "4xl": {
        heading: "text-heading-4xl"
      },
      "5xl": {
        heading: "text-heading-5xl"
      },
      "display-lg": {
        heading: ""
      },
      "display-md": {
        heading: ""
      },
      "display-sm": {
        heading: ""
      }
    },
    leadSize: {
      "2xs": {
        lead: "text-heading-2xs"
      },
      xs: {
        lead: "text-heading-xs"
      },
      sm: {
        lead: "text-heading-sm"
      },
      md: {
        lead: "text-heading-md"
      },
      lg: {
        lead: "text-heading-lg"
      },
      xl: {
        lead: "text-heading-xl"
      },
      "2xl": {
        lead: "text-heading-2xl"
      }
    },
    eyebrowSize: {
      "2xs": {
        eyebrow: "text-heading-2xs"
      },
      xs: {
        eyebrow: "text-heading-xs"
      },
      sm: {
        eyebrow: "text-heading-sm"
      },
      md: {
        eyebrow: "text-heading-md"
      },
      lg: {
        eyebrow: "text-heading-lg"
      },
      xl: {
        eyebrow: "text-heading-xl"
      },
      "2xl": {
        eyebrow: "text-heading-2xl"
      }
    }
  },
  defaultVariants: {
    headingSize: { initial: "sm", lg: "lg" },
    leadSize: { initial: "xs", md: "sm" },
    eyebrowSize: "xs"
  },
  compoundVariants: []
});
export {
  a as headingStyling
};
//# sourceMappingURL=index-blueprint.es.js.map
